const preventDefault = callback => e => {
  if (e && e.preventDefault) {
    e.preventDefault()
  }
  if (callback) {
    callback()
  }
}

export default preventDefault



/** WEBPACK FOOTER **
 ** ./src/utils/prevent-default/prevent-default.js
 **/